<template>
  <v-container fluid class="px-8 py-0">
    <template v-slot:after-heading> </template>
    <v-row class="d-flex justify-space-between mx-1 mb-0">
      <div>
        <v-row>
        
          <v-text-field
            v-model="listQuery.name"
            label="拆迁公司名称"
            hide-details
            single-line
            class="mx-3 mb-3"
            style="max-width: 100px;"
          />
         
        </v-row>
      </div>
      <div>
        <v-row class="mt-2">
          <v-btn @click="getQuery" color="primary" class="mx-1">
            查询
            <v-icon right>mdi-magnify</v-icon>
          </v-btn>

          <v-btn @click="resetQuery" color="primary" class="mx-1">
            重置
            <v-icon right>mdi-lock-reset</v-icon>
          </v-btn>
        
          <!-- <export-excel
            v-if="isAdminRole"
            :fields="exportMBFields"
            worksheet="户主数据"
            name="魏塘街道公寓房安置户主数据.xls"
            type="xlsx"
            :fetch="getListforExport"
            class="mx-1"
          >
            <v-btn v-if="isAdminRole" color="primary">
              导出
              <v-icon right>mdi-arrow-down-bold-circle-outline</v-icon>
            </v-btn>
          </export-excel> -->
           

          <div v-if="isAdminRole">
            <AddCompanyDialog />
          </div>
        </v-row>
      </div>
    </v-row>

    <v-alert
      :value="alert"
      color="red"
      dark
      border="top"
      icon="mdi-bell"
      transition="scale-transition"
    >
      {{ alert_text }}
    </v-alert>
    <v-simple-table fixed-header class="pa-3">
      <template v-slot:default>
        <thead>
          <tr>
            <th>ID</th>
            <th>公司名称</th>
            <th class="text-left">负责区域</th>
            
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in items" :key="row.id" :disabled="row.is_freeze==1">
            <td>{{ row.id }}</td>
            <td>
              <!-- <v-icon style="with:30px;color:#a0a0a0;font-size:14px;"  v-if="row.is_freeze==1" v-text="icons.lock.icon" /> -->
              <!-- <v-icon style="with:30px;color:#a0a0a0;font-size:14px;"  v-if="row.is_freeze==1" >{{ icons.lock.icon }}</v-icon> -->
              {{ row.name }}
            </td>
            <td  class="text-left" v-html="row.remark" style="white-space: pre;">
            </td>
            
            <td>
              <!-- <v-btn color="warning" icon @click="goDetails(row.id)">
                <v-icon left>{{ icons.list.icon }}</v-icon>
              </v-btn> -->
              <v-btn color="green" icon @click="get_company(row.id)">
                <v-icon left>{{ icons.edit.icon }}</v-icon>
              </v-btn>
             
              <v-btn color="red" icon @click="removeCompany(row.id)">
                <v-icon left>{{ icons.delete.icon }}</v-icon>
              </v-btn>
            
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-pagination
      v-model="listQuery.page"
      :circle="circle"
      :disabled="disabled"
      :length="total_pages"
      :next-icon="nextIcon"
      :prev-icon="prevIcon"
      :total-visible="totalVisible"
      :value="listQuery.page"
      @input="paginationChangeHandler"
      class="my-3"></v-pagination>
     <div style="text-align: right;width: 100%;margin-bottom: 20px;margin-top: -44px;max-width: 100%;color: gray;">共有{{ total_items }}条记录</div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="1200">
    
    <v-container class="px-3 my-container" style="background-color: rgba(90, 90, 90, 0.9);">

      <div class="px-7 pb-5" height="800px">
        <v-card-title class="my-10"><h1>编辑拆迁公司</h1></v-card-title>
        <v-row>
          <v-text-field
            v-model="company.name"
            color="yellow darken-3"
            label="公司名称"
            required
            class="mx-6"
            style="width:120px"
          ></v-text-field>
          
        </v-row>
        <v-row>

        <v-textarea
          v-model="company.remark"
          color="yellow darken-3"
          label="负责区域"
          required
          class="mx-6"
          style="width:400px"
        ></v-textarea>

        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <span class="mt-6 mx-3 orange--text" style="font-size:14px">
            本系统由 九色鹿网络 提供技术支持。
          </span>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelEditDialog">取消</v-btn>
          <v-btn color="primary" @click="confirmEditDialog">确认</v-btn>
        </v-card-actions>
      </div>
    </v-container>
  </v-dialog>
  </v-container>
</template>

<script>
import {
  fetchCompanies,
  updateCompany,
  fetchCompany,
  deleteCompany,
} from "@/api/companies";


export default {
  name: "Company",
  components: {
    AddCompanyDialog: () => import("./addCompanyDialog"),
   
  },
  data: () => ({
    printObj: {
      id: "printMe",
      popTitle: "good print",
      extraCss: "https://www.baidu.com",
      extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
    },
    dialog: false,
    Interest:false,
    snackbar: false,
    text: "",
    timeout: 3000,
    construction_menu:"",
    completed_menu:"",
    delivery_menu:"",
    icons: {
      edit: {
        color: "blue",
        icon: "mdi-file-edit"
      },
    
      list: {
        color: "",
        icon: "mdi-format-list-bulleted"
      },
      delete: {
        color: "green",
        icon: "mdi-delete"
      },
    
    },
    start_menu: "",
    end_menu: "",

    alert: false,
    alert_text: "",
    
    items: [],
    company: {},
    listQuery: {
      page: 1,
      limit: 12,
      garden_name: undefined,
    },
    search: "",
    awaitingSearch: false,
    circle: true,
    disabled: false,
    length: 10,
    nextIcon: "mdi-chevron-right",
    prevIcon: "mdi-chevron-left",
    totalVisible: 10,
    total_pages: 0,
    total_items:0,

  }),

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("administrator")) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getList();
  },
  mounted: {
   
  },
  methods: {
   
    getQuery() {
      this.listQuery.page = 1;
      this.getList();
    },
    changed() {},
    getList() {
      this.listLoading = true;
      this.listQuery.limit = 12;
      console.log(this.listQuery);
      fetchCompanies(this.listQuery).then(response => {
        this.items = response.data.items;
        this.total_pages = response.data._meta.total_pages;
        this.total_items = response.data._meta.total_items;
        console.log(this.items);

        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },

   
    getListforExport() {
      this.listLoading = true;
      this.listQuery.page = 1;
      this.listQuery.limit = 500;
      fetchCompanies(this.listQuery).then(response => {
        this.exportItems = response.data.items;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
      return this.exportItems;
    },
    
    cancelDialog() {
      this.dialog = false;
    },
    cancelEditDialog() {
      this.dialog = false;
      this.company = {};
    },
   
    get_company(company_id) {
      this.dialog = true;
      fetchCompany(company_id).then(response => {
        this.company = response.data;
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    confirmEditDialog() {
      const tempData = this.company;
      console.log(tempData);
      updateCompany(this.company.id,tempData).then(() => {
        this.dialog = false;
        this.company = {};
        this.getList()
      });
    },
    resetQuery() {
      this.listQuery.garden_name = undefined;
      this.getList();
      console.log("resetQuery");
    },
    
    removeCompany(id) {
      this.$confirm("确认删除当前数据?").then(res => {
        if (res) {
          deleteCompany(id).then(response => {
            // console.log('response: ', response)
            if (response.data.error) {
              this.alert_text = response.data.error;
              this.alert = true;
            } else {
              this.getList();
              // Just to simulate the time of the request
              this.text = "当前数据删除成功！";
              this.snackbar = true;
            }
          });
        }
      });
    },
    // goDetails(id) {
    //   // console.log(row.id)
    //   this.$router.push({
    //     name: "建设主体详情",
    //     params: { id: id }
    //   });
    // },
    paginationChangeHandler(pageNumber) {
      console.log("paginationChangeHandler, pageNumber: ", pageNumber);
      this.listQuery.page = pageNumber;
      this.getList();
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },

  }
};
</script>

<style lang="scss" scoped>
$colors: (
  0 #03444d,
  1 #80594a,
  2 #4e3152,
  3 #856936,
  4 #255834,
  5 #2e3761,
  6 #6d2b36,
  7 #2b6d6a,
  8 #413370,
  9 #754719
);

$color: nth($colors, random(length($colors)));

@each $i in $colors {
  .bill_background-#{nth($i,1)} {
    background-color: nth($i, 2) !important;
    color: rgb(241, 233, 233) !important;
    font-weight: 500 !important;
    border-radius: 1px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 2px;
    padding-bottom: 2px;
    width: 92px;
  }
}

tr:hover {
  background-color: #0282b4 !important;
  color: rgb(224, 221, 221);
}

table,
thead,
tr {
  // color: rgb(160, 160, 160);
  font-weight: 400;
}
th,
td {
  text-align: center !important;
  vertical-align: middle;
  padding: 0 2px 0 2px !important;
}
.dialog-style {
  background-color: rgb(40, 40, 40) !important;
}

.tooltip {
  font-size: 16px;
}

.only-print {
  display: none;
}

@page {
  /* size: A4; */
  size: landscape;
  margin: 1px 1px;
}

@media print {
  .A4 {
    background: white;
    /* width: 21cm;
  height: 29.7cm; */
    width: 1122px;
    height: 794px;
    display: block;
    margin: auto;
    padding: auto;
    margin-bottom: 0cm;
    box-shadow: 0 0 0.5cm 0.5cm rgba(90, 88, 88, 0.1);
    overflow-y: auto;
    box-sizing: border-box;
  }

  .dialog-style {
    background-color: rgb(255, 254, 254) !important;
  }

  .no-print {
    display: none;
  }

  .only-print {
    display: block;
    font-weight: 400;
    font-size: 12px !important;
  }

  table,
  th,
  td {
    color: black !important;
    font-weight: 800;
    border: 1px solid !important;
    border-collapse: separate !important;
    // border-spacing: 5 !important;
  }
}
</style>
